// extracted by mini-css-extract-plugin
export var bbc = "LogosSection-module--bbc--88ecb";
export var christies = "LogosSection-module--christies--26f76";
export var colStyles = "LogosSection-module--colStyles--9969a";
export var desktopFirstRow = "LogosSection-module--desktopFirstRow--d85ea";
export var desktopSecondRow = "LogosSection-module--desktopSecondRow--3ba56";
export var desktopWrapper = "LogosSection-module--desktopWrapper--1ec99";
export var dowJones = "LogosSection-module--dowJones--18fe1";
export var englishHeritage = "LogosSection-module--englishHeritage--8b82f";
export var greenPeace = "LogosSection-module--greenPeace--8a838";
export var homePageLogosParagraph = "LogosSection-module--homePageLogosParagraph--c482a";
export var honda = "LogosSection-module--honda--2d31e";
export var logosParagraph = "LogosSection-module--logosParagraph--825fb";
export var manchesterCity = "LogosSection-module--manchesterCity--5b073";
export var nature = "LogosSection-module--nature--89f76";
export var nikkei = "LogosSection-module--nikkei--e0799";
export var oxfordUni = "LogosSection-module--oxfordUni--47c78";
export var paragraph = "LogosSection-module--paragraph--e6d79";
export var penguin = "LogosSection-module--penguin--b011b";
export var saveTheChildren = "LogosSection-module--saveTheChildren--c2066";
export var svgStyles = "LogosSection-module--svgStyles--c9016";
export var tripAdvisor = "LogosSection-module--tripAdvisor--9867f";
export var unicef = "LogosSection-module--unicef--f89fe";